import axios from '../../axios'



 // 列表-我的任务
export const myTasks = (data) => {
    return axios({
        url: '/system/sysTaskDeal/getMyTasks',
        method: 'post',
        data
    })
}

// 列表-已处理的任务
export const solvedTasks = (data) => {
  return axios({
    url: '/system/sysTaskDeal/getSolvedTasks',
    method: 'post',
    data
  })
}

// 列表-未查看的任务
export const unreadTasks = (data) => {
  return axios({
    url: '/system/sysTaskDeal/getUnreadTasks',
    method: 'post',
    data
  })
}

// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/system/sysTaskDeal/delete',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/sysTaskDeal.js